exports.REG_EXP = {
	PASSWORD: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{8,}$/,
	EMAIL: /^[a-zA-Z0-9._%+-]+@[a-z][a-z0-9.-]+[.][a-z]{2,5}$/,
	NUMBER: /^[0-9]*$/,
	NO_SPECIAL_CHARS: /^[a-zA-Z0-9\s]*$/,
};
